import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/messages").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-messages">
      <h1 className="font-display font-extrabold text-3xl md:text-4xl">Messages</h1>
      <p className="text-gray-500 mt-1 text-sm mb-6">{items.length} messages</p>

      <ul className="space-y-3">
        {items.map(m => (
          <li key={m.id} className="bg-white border border-gray-100 rounded-2xl p-5" data-testid={`message-${m.id}`}>
            <div className="flex items-center justify-between mb-2">
              <p className="font-display font-bold text-base">{m.name}</p>
              <p className="text-xs text-gray-500">{new Date(m.created_at).toLocaleString()}</p>
            </div>
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{m.message}</p>
          </li>
        ))}
        {items.length === 0 && <p className="text-gray-500 text-sm">No messages yet.</p>}
      </ul>
    </div>
  );
}
